<template>
  <div v-if="currentPrice">
    <LcDescriptionList class="gap-none">
      <dt class="flex gap-100 items-center paragraph-bold">
        {{ formattedPlay }}
      </dt>
      <dd>{{ formattedWager }}</dd>

      <template v-for="addOn of currentPrice.addOns" :key="addOn.name">
        <dt>
          {{ $t('tiertable.fielddivider') }}
          {{ $t(`highfrequencygame.addon.${addOn.name}`) }}
        </dt>
        <dd>{{ formatMoney(addOn.charge) }}</dd>
      </template>
    </LcDescriptionList>

    <LcDescriptionList
      class="flex items-center justify-between py-025 px-050 rounded-s mt-150"
      :class="{
        'bg-accent-win-win': discount > 0,
        'bg-secondary-secondary': discount <= 0,
      }"
    >
      <dt>
        {{ $t('highfrequencygame.pricelist.games.label', currentPrice.numberOfDraws) }}
      </dt>
      <dd class="flex gap-100 items-center justify-end font-medium">
        <HighFrequencyGameDiscountBadge
          v-if="discount > 0"
          v-bind="{ discount }"
          class="my-025"
          size="small"
        />

        {{
          $t('highfrequencygame.pricelist.games.value', {
            amount: currentPrice.numberOfDraws,
          })
        }}
      </dd>
    </LcDescriptionList>
  </div>
</template>

<script lang="ts" setup>
import type { HighFrequencyPriceBreakdown } from '@lottocom/price-calculation'

type CustomPriceBreakdown = Pick<
  HighFrequencyPriceBreakdown,
  'addOns' | 'discountPercentage' | 'numberOfDraws' | 'numberOfSpots' | 'wager'
>

type Props = {
  currentPrice?: Maybe<CustomPriceBreakdown>
}

const { currentPrice } = defineProps<Props>()
const { t } = useI18n()

const discount = computed(() => {
  if (!currentPrice) return 0
  return currentPrice.discountPercentage
})

const formattedWager = computed(() => {
  if (!currentPrice) return null
  return formatMoney(currentPrice.wager)
})

const formattedPlay = computed(() => {
  if (!currentPrice) return
  return t('highfrequencygame.pricelist.play.label', {
    count: currentPrice.numberOfSpots,
  })
})
</script>
